import {
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	useSidebar,
} from '@/components/ui/sidebar'
import { useStytchWorkspaces } from '@/hooks/useStytchWorkspaces'
import { useAppDispatch } from '@/redux/hooks/useAppState'
import { setIsWorkspaceSelectorOpen } from '@/redux/store/slices/ui/uiSlice'
import { Organization } from '@stytch/vanilla-js'
import { Building2 } from 'lucide-react'
import * as React from 'react'
import { useParams } from 'react-router-dom'

export function WorkspaceSwitcher() {
	const { open } = useSidebar()
	const { workspaceId = '' } = useParams()
	const { workspaces } = useStytchWorkspaces()
	const dispatch = useAppDispatch()
	const workspaceMap = workspaces.reduce(
		(mp, workspace) => {
			mp[workspace.organization_slug] = workspace
			return mp
		},
		{} as Record<string, Organization>
	)

	const currentWorkspace = workspaceMap[workspaceId] ?? workspaces[0]

	const openWorkspaceSelector = React.useCallback(() => {
		dispatch(setIsWorkspaceSelectorOpen(true))
	}, [dispatch])

	if (!currentWorkspace) {
		return null
	}

	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<SidebarMenuButton
					onClick={openWorkspaceSelector}
					tooltip={currentWorkspace.organization_name}
					size="lg"
					className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
				>
					<div className="bg-sidebar-primary text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg">
						<Building2 className="size-4" />
					</div>
					{open && <span className="truncate">{currentWorkspace.organization_name}</span>}
				</SidebarMenuButton>
			</SidebarMenuItem>
		</SidebarMenu>
	)
}
